"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Closingcta() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="501" id="closingcta" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[60vh] lg:min-h-[80vh]">
        {}
        <div ref={leftRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_process.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_process.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_process.png-wvc-sizes" alt="Precision industrial engraving process on metal" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(216, 50%, 12%, 0.9) 0%, hsla(216, 40%, 18%, 0.8) 100%)",
          opacity: 0.85
        }} />
          <div className="absolute inset-0 bg-background/40" />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 right-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 right-0 w-px bg-border" />
            <div className="absolute right-0 h-24 w-px bg-primary opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500" />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 text-primary">
                Solutions
              </p>
              <h2 className="font-default font-bold leading-[1.05] tracking-tight text-accent mb-6" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)"
            }}>
                Precision Engraving
              </h2>
              <p className="font-default text-base sm:text-lg text-foreground/80 leading-relaxed mb-10 max-w-md">
                From custom phenolic tags to complex industrial marking, we deliver high-durability solutions engineered for your specific environment.
              </p>
              <Button asChild size="lg" className="rounded-md px-8 py-6 h-auto text-base font-bold transition-transform duration-300 hover:scale-105 shadow-lg" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                <Link to="/ServicesPage">
                  View Services
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`group relative flex-1 overflow-hidden min-h-[60vh] lg:min-h-[80vh] transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        backgroundColor: "var(--card)"
      }}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_label_manufacturing.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_label_manufacturing.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_label_manufacturing.png-wvc-sizes" alt="Custom label manufacturing and quality control" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />

          {}
          <div className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsla(216, 40%, 18%, 0.9) 0%, hsla(216, 40%, 20%, 0.8) 100%)"
        }} />

          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 left-0 h-full w-px overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-px bg-border" />
            <div className="absolute left-0 h-24 w-px bg-primary opacity-0 group-hover:opacity-80 group-hover:animate-[tide_2.5s_ease-in-out_infinite] transition-opacity duration-500" />
          </div>

          {}
          <div className="relative z-10 flex h-full items-center justify-center p-8 sm:p-12 lg:p-16">
            <div className="max-w-xl">
              <p className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 text-primary">
                Contact
              </p>
              <h2 className="font-default font-bold leading-[1.05] tracking-tight text-accent mb-6" style={{
              fontSize: "clamp(2.5rem, 5vw, 5rem)"
            }}>
                Get a Quote
              </h2>
              <p className="font-default text-base sm:text-lg leading-relaxed mb-10 max-w-md text-foreground/80">
                Ready to start your project? Our team is standing by to provide expert guidance and fast turnaround times for your custom orders.
              </p>
              <Button asChild size="lg" className="rounded-md px-8 py-6 h-auto text-base font-bold transition-transform duration-300 hover:scale-105 shadow-lg" style={{
              backgroundColor: "var(--accent)",
              color: "var(--accent-foreground)"
            }}>
                <Link to="/ContactPage">
                  Request Quote
                  <ArrowRight className="ml-1 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tide {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(100%); }
        }
      `}</style>
    </section>;
}